// utils/authSession.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
import { api } from "@/services";

const BASE_LOGOUT = "/authenticate/logout";

/**
 * Apaga um cookie pelo nome, utilizando data expirada e path=/.
 * Inclui SameSite=Lax para maior compatibilidade.
 */
function deleteCookie(name: string) {
  document.cookie = `${name}=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; SameSite=Lax`;
}

/**
 * Salva token + metadados na sessionStorage.
 */
export function saveTokenToSessionStorage(token: string, expireIn: string | number): void {
  const tokenData = {
    token,
    expireIn: String(expireIn),
    dateCreated: Date.now(),
  };
  sessionStorage.setItem("token", JSON.stringify(tokenData));
}

/**
 * Remove credenciais locais e tenta invalidar a sessão no backend.
 * Sempre limpa storage e cookies, mesmo que a chamada de logout falhe.
 */
export async function deleteSessionStorage(): Promise<void> {
  try {
    await api.post<any>(BASE_LOGOUT);
  } catch (error) {
    console.error("Error on backend logout:", error);
  } finally {
    // Limpeza local garantida
    try {
      sessionStorage.removeItem("token");
    } catch {
      /* noop */
    }
    deleteCookie("kasdlgouasdn");
    deleteCookie("expireIn");
    deleteCookie("tokenDate");
  }
}
